import { Link } from "react-router-dom";
import { articles, timelineEvents, type TimelineEvent } from "@/mocks/content";

const toneDot: Record<TimelineEvent["tone"], string> = {
  accent: "bg-accent-500",
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
};

const mysteryIds = ["a2", "a7", "a10"];

export default function ArchiveSection() {
  const mysteries = mysteryIds.map((id) => articles.find((a) => a.id === id)!).filter(Boolean);

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-12">
          {/* timeline */}
          <div>
            <div className="flex items-end justify-between">
              <h2 className="flex items-center gap-2 font-display text-2xl font-black text-foreground-950">
                <i className="ri-history-line text-accent-500" aria-hidden="true" />
                昨日时间轴演进
              </h2>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                48 小时全程
              </span>
            </div>
            <div className="relative mt-6 border-l-2 border-background-300 pl-6">
              {timelineEvents.map((ev, i) => (
                <div key={i} className="relative pb-6 last:pb-0">
                  <span
                    className={`absolute -left-[31px] top-0.5 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 ${toneDot[ev.tone]}`}
                  />
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-display text-sm font-bold text-foreground-950">
                      {ev.time}
                    </span>
                    <span
                      className={
                        "rounded-full px-2 py-0.5 text-[10px] font-medium text-background-50 " +
                        toneDot[ev.tone]
                      }
                    >
                      {ev.tag}
                    </span>
                  </div>
                  <p className="mt-1 font-medium text-foreground-900">{ev.title}</p>
                  <p className="mt-0.5 text-sm leading-relaxed text-foreground-600">{ev.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* mystery archive */}
          <div className="rounded-2xl bg-background-100 p-6 md:p-8">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-display text-2xl font-black text-foreground-950">
                <i className="ri-question-mark text-secondary-500" aria-hidden="true" />
                未解之谜档案
              </h2>
              <span className="text-xs tracking-widest text-foreground-500">只归档，不臆断</span>
            </div>
            <div className="mt-5 flex flex-col gap-3">
              {mysteries.map((a, i) => (
                <Link
                  key={a!.id}
                  to={`/article/${a!.slug}`}
                  className="group flex gap-4 rounded-xl bg-background-50 p-4 transition-colors hover:bg-primary-50"
                >
                  <span className="font-display text-3xl font-black leading-none text-background-300 group-hover:text-primary-400">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex flex-1 flex-col">
                    <span className="font-display text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-600 md:text-lg">
                      {a!.title}
                    </span>
                    <span className="mt-1.5 line-clamp-2 text-sm text-foreground-600">
                      {a!.summary}
                    </span>
                  </span>
                  <span className="hidden shrink-0 items-center self-center text-foreground-400 sm:flex">
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}